import { yupResolver } from "@hookform/resolvers/yup";
import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import FormInput from "../Form/FormInput";

const validationSchema = Yup.object({
  email: Yup.string().email("Keine valide Email").nullable(),
});

export interface ResendFormValues {
  email?: string;
}
export type ResendFormFunction = (values: ResendFormValues) => Promise<any>;

interface Props {
  onSubmit: ResendFormFunction;
  loading?: boolean;
  initi: ResendFormValues;
}

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  streetWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  street: {
    marginRight: 30,
  },
}));
const ResendForm: React.FC<Props> = ({ onSubmit, loading, initi }) => {
  const classes = useStyles();
  const methods = useForm<ResendFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...initi },
    mode: "all",
  });
  const { handleSubmit } = methods;
  return (
    <FormProvider {...methods}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <FormInput
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="email"
        />
        <Button
          type="submit"
          fullWidth
          disabled={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleSubmit(onSubmit)}
        >
          Erneut senden
        </Button>
      </form>
    </FormProvider>
  );
};

export default ResendForm;
